import React from 'react';

import { Body, Intro, Title } from '@edx/components/typography';

export type Benefit = {
  title: string;
  description: string;
};

type Props = {
  benefits: Benefit[];
};

export const PricingBenefits: React.FC<Props> = ({ benefits }) => (
  <section className="py-8 md:py-16 text-gray-400">
    <header>
      <Intro size="small" className="text-center">
        Disfruta de todas las ventajas a un precio reducido
      </Intro>
    </header>

    <div className="mt-12">
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 text-center gap-6">
        {benefits.map(({ title, description }) => (
          <li key={title} className="px-8 lg:px-0">
            <Title size="small">{title}</Title>
            <Body className="mt-2 text-gray-500">{description}</Body>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
